(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["combined-listing-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('combined-listing-picker')) {
    customElements.define('combined-listing-picker', class extends HTMLElement {
      connectedCallback() {
        this.navigating = false;
        this.controller = new AbortController();
        this.requests = new WeakMap();
        const options = { signal: this.controller.signal };
        this.addEventListener('pointerover', (event) => this.preload(event), options);
        this.addEventListener('focusin', (event) => this.preload(event), options);
        this.addEventListener('click', async (event) => {
          const link = event.target.closest('[data-style-option-values] a');
          if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (this.navigating) return;
          this.navigating = true;
          this.setAttribute('aria-busy', 'true');
          const url = await this.resolveLink(link);
          if (this.isConnected) window.location.assign(url);
        }, options);
      }

      disconnectedCallback() {
        this.controller.abort();
      }

      preload(event) {
        const link = event.target.closest('[data-style-option-values] a');
        if (link) this.resolveLink(link);
      }

      resolveLink(link) {
        if (!this.requests.has(link)) {
          this.requests.set(link, this.resolveVariant(link));
        }
        return this.requests.get(link);
      }

      async resolveVariant(link) {
        const destination = new URL(link.href);
        const request = new URL(destination);
        request.searchParams.set('section_id', 'combined-listing-variant');
        request.searchParams.set('option_values', link.parentElement.dataset.styleOptionValues);
        try {
          const response = await fetch(request, { signal: AbortSignal.any([this.controller.signal, AbortSignal.timeout(5000)]) });
          if (!response.ok) return destination.href;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const variantId = JSON.parse(html.querySelector('[data-combined-listing-variant]')?.textContent || 'null');
          if (variantId) destination.searchParams.set('variant', variantId);
          link.href = destination.href;
        } catch {
          return destination.href;
        }
        return destination.href;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
